import { SettlementCustomerByDocumentMovementDto } from "../../../dtos/transactions/SettlementCustomerByDocumentMovementDto";
import { format } from "date-fns";
import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import React from "react";
import {useTranslation} from "react-i18next";

interface IProps {
    items: SettlementCustomerByDocumentMovementDto[];
}

export const SettlementCustomerByDocumentMovementTable = ({ items }: IProps) => {
    const pageSizes = [10, 25, 50, 100];
    const {t} = useTranslation();

    return (
        <>
            <div className={"overflow-auto"}>
                <DataGrid
                    dataSource={items}
                    sorting={{ mode: "multiple" }}
                    allowColumnReordering={true}
                    rowAlternationEnabled={false}
                    showBorders={false}
                    showRowLines={true}
                    allowColumnResizing={true}
                    selection={{ mode: "single" }}
                    loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
                >
                    <ColumnChooser enabled={true} />
                    <GroupPanel visible={true} />
                    <SearchPanel visible={true} highlightCaseSensitive={true} />
                    <Grouping autoExpandAll={false} />

                    <Column dataField="tableMovementType"
                            dataType="string"
                            caption={"Movement Type"}
                            width={100}
                            cellRender={(column: any) => {
                                return <MovementTypeColumn column={column} />
                            }} />
                    <Column width={150} dataField={"period"} dataType={"datetime"} caption={"Period"}
                        sortOrder={"asc"}
                        sortIndex={1} />
                    <Column width={150} dataField={"companyId"} dataType="string" />
                    <Column width={150} dataField={"companyName"} dataType="string" />
                    <Column width={150} dataField={"customerId"} dataType="string" />
                    <Column width={150} dataField={"customerName"} dataType="string" />
                    <Column width={150} dataField={"contractId"} dataType="string" />
                    <Column width={150} dataField={"contractName"} dataType="string" />
                    <Column width={150} dataField={"arApDocumentId"} dataType="string" />
                    <Column width={150} dataField={"currencyName"} dataType="string" />
                    <Column width={150} dataField={"currencyId"} dataType="string" />
                    <Column width={150} dataField={"saleToCustomer"} dataType="number" />
                    <Column width={150} dataField={"saleToCustomerLocal"} dataType="number" />
                    <Column width={150} dataField={"paymentFromCustomer"} dataType="number" />
                    <Column width={150} dataField={"paymentFromCustomerLocal"} dataType="number" />
                    <Column width={150} dataField={"documentType"} dataType="number" />
                    <Column width={150} dataField={"businessTransaction"} dataType="number" />

                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                    <Paging defaultPageSize={10} />
                </DataGrid>
            </div>
        </>
    )
}
